import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import { useLocation, useNavigate } from "react-router";
import { useFieldArray, useForm } from "react-hook-form";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { StepHeader } from "./StepHeader";
import { Form } from "reactstrap";
import Required from "../../../MyComp/UI/form/Required";
import MySelect from "../../../MyComp/UI/form/MySelect";
import MyInput from "../../../MyComp/UI/form/MyInput";
import MyDate from "../../../MyComp/UI/form/MyDate";
import moment from "moment";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import MyCreateSelect from "../../../MyComp/UI/form/MyCreateSelect";
import MyCheck from "../../../MyComp/UI/form/MyCheck";
import MyTextArea from "../../../MyComp/UI/form/MyTextArea";

import { toast } from "react-toastify";
import useLogout from "../../../hooks/useLogout";
import MyButton from "../../../MyComp/UI/form/MyButton";
import { doctorQualificationRegistration } from "../../../api/doctor";
import MyEmail from "../../../MyComp/UI/form/MyEmail";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import { createPharmacyAdditopnalStore, getZipDetailsAPI } from "../../../api/master/indes";
import { stepthreePharmacyDetails } from "../../../api/dropdown";
import MyGmailAddressSearch from "../../../MyComp/UI/form/MyGmailAddressSearch";

const StepTwoPharmacy = () => {
  const location = useLocation();
  const { logout } = useLogout();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      medical_qualification: null,
      storeTypeDD: [],
      countryDD: [{ value: "India", label: "India" }],
      country: { value: "India", label: "India" },
      stateDD: [],
      cityDD: [],
      paymentModeDD: [
        {
          value: "card",
          label: "Card",
        },
        {
          value: "cash",
          label: "Cash",
        },
        {
          value: "net_banking",
          label: "Net Banking",
        },
        {
          value: "upi",
          label: "UPI",
        },
      ],
      deliveryRadiusDD: [
        {
          value: "1",
          label: "1 KM",
        },
        {
          value: "2",
          label: "2 KM",
        },
        {
          value: "3",
          label: "3 KM",
        },
        {
          value: "4",
          label: "4 KM",
        },
        {
          value: "5",
          label: "5 KM",
        },
        {
          value: "6",
          label: "6 KM",
        },
        {
          value: "7",
          label: "7 KM",
        },
        {
          value: "8",
          label: "8 KM",
        },
        {
          value: "9",
          label: "9 KM",
        },
        {
          value: "10",
          label: "10 KM",
        },
      ],

      store_image: null,
      store_img: null,

      pan_image: null,
      pan_img: null,

      drug_img: null,
      drug_image: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,

      catalog_image: null,
      catalog_img: null,

      fssai_image: null,
      fssai_img: null,

      cheque_image: null,
      cheque_img: null,

      objectionKeys: [],
      approvedKeys: [],

      degree: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],
      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "degree",
  });
  const doctorId = location?.state?.doctorId || null;
  console.log("");

  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const isLoading = watch("isLoading");
  const [imageOpen, setImageOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };
  console.log(location, "location3")

  const onFormSubmit = (data) => {
    console.log(data, "data");

    const formData = new FormData();

    // TEXT FIELDS
    formData.append("pharmacyId", location?.state?.pharmacyId)
    // formData.append("name", data.owner_name || "");
    formData.append("pincode", data.pincode || "");
    formData.append("state", data.state || "");
    formData.append("city", data.city || "");
    formData.append("address", data.address || "");
    formData.append("email", data.email || "");
    formData.append("phoneNumber", data.alt_mobile || "");
    formData.append("country", data.country?.value || data.country || "");
    formData.append("latitude", data.latitude || "");
    formData.append("longitude", data.longitude || "");
    formData.append("map_link", data.map_link || "");




    // if (!(data.aadhaar_f_img instanceof File)) {
    //   toast.error("AADHAAR front image is required");
    //   return;
    // }
    // formData.append("aadhar_front", data.aadhaar_f_img);

    // if (!(data.aadhaar_b_img instanceof File)) {
    //   toast.error("AADHAAR back image is required");
    //   return;
    // }
    // formData.append("aadhar_back", data.aadhaar_b_img);

    // if (!(data.pan_img instanceof File)) {
    //   toast.error("PAN image is required");
    //   return;
    // }
    // formData.append("pan_image", data.pan_img);


    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }


    if (mode === "Add" || mode === "Edit") {
      createPharmacyAdditopnalStore(formData)
        .then((res) => {
          if (res.data.status === true) {
            // toast.success(res.data.message);
            navigate("/pharmacy-registration/pharmacy-medicine", {
              // state: { mode: mode, pharmacyId: res.data.data?.pharmacyId },
              state: { mode: mode, pharmacyId: mode === "Add" ? res.data.data?.pharmacyId : location.state.pharmacyId },
            });;
          }
        })
        .catch((err) => toast.error(err?.response?.data?.message));
    }
  };


  useEffect(() => {
    if (watch("pincode") && watch("pincode").toString().length === 6) {
      const body = {
        pin_code: watch("pincode"),
      };
      getZipDetails(body);
    }
  }, [watch("pincode")]);

  const getZipDetails = (body) => {
    setLoading(true);
    getZipDetailsAPI(body)
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          const responseData = res.data.data[0];
          setValue("city", responseData?.district_name);
          setValue("state", responseData?.state_name);
          trigger('state')
          trigger("city")
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    const body = { pharmacyId: location.state.pharmacyId };
    if (mode === "Edit") {
      stepThreeDetails(body);
    }
  }, []);
  const stepThreeDetails = (body) => {
    stepthreePharmacyDetails(body)
      .then((res) => {
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          const data = res.data.data;

          console.log(data, "stepThreeDetails");


          setValue("pincode", data.pincode || "");
          // setValue("city", data.district || "");
          // setValue("state", data.state || "");
          setValue("address", data.address || "");


          setValue("alt_mobile", data.phoneNumber || "");
          setValue("email", data.email || "");

          setValue("isLoading", false);
          setValue("map_link", data.map_link || "");
          setValue("latitude", data.latitude || "");
          setValue("longitude", data.longitude || "");
          setValue("selectedAddress", {
            label: data.address,
            value: data.address,
          });

        }
        else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        }
        else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <Head title={"Pharmacy Registration | Additional Details"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Pharmacy Registration"}
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <StepHeader current={3} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row className=" ">
                <h5 className="my-3">{"Additional Details"}</h5>
                {/* <Col md="2">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Owner Name"
                    name="owner_name"
                    placeholder="Enter Owner Name"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                {/* <Col md="2">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="aadhaar_f_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"AADHAAR Front Image"}
                    errors={errors}
                    register={register}
                    image={"aadhaar_f_img"}
                    image_url={"aadhaar_f_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                <Col md="2">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="aadhaar_b_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"AADHAAR Back Image"}
                    errors={errors}
                    register={register}
                    image={"aadhaar_b_img"}
                    image_url={"aadhaar_b_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                <Col md="2">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="pan_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"PAN Image"}
                    errors={errors}
                    register={register}
                    image={"pan_img"}
                    image_url={"pan_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col> */}

                {/* <Col md={2}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Country"}
                    name={"country"}
                    placeholder={"Select country"}
                    required
                    options={watch("countryDD")}
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                {/* <Col md="2" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Pin Code"}
                    name={"pin_code"}
                    placeholder={"Enter pin code"}
                    required
                    min={6}
                    max={6}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"District"}
                    name={"city"}
                    placeholder={"Enter city"}
                    required
                    disabled={mode == "Approval"}
                    readonly
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"State"}
                    name={"state"}
                    placeholder={"Enter state"}
                    required
                    disabled={mode == "Approval"}
                    readonly
                  />
                </Col> */}
                <Col md="3" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Alternate Mobile"}
                    name={"alt_mobile"}
                    placeholder={"Enter alternate mobile"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>

                <Col md="3" className={``}>
                  <MyEmail
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Email"}
                    name={"email"}
                    placeholder={"Enter email"}
                    required
                    disabled={mode == "Approval"}
                   
                  />
                </Col>
                {/* <Col md="4">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Full Address"
                    name="full_address"
                    placeholder="Enter full address"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col> */}
                <Col lg="6">
                  <MyGmailAddressSearch
                    value={watch("selectedAddress")}
                    onChange={(val) => setValue("selectedAddress", val)}
                    watch={watch}
                    setValue={setValue}
                    errors={errors}
                    trigger={trigger}
                  />
                </Col>

                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Pin Code"}
                    name={"pincode"}
                    placeholder={"Enter pin code"}
                    required
                    min={6}
                    max={6}
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"State"}
                    name={"state"}
                    placeholder={"Select state"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"City"}
                    name={"city"}
                    placeholder={"Select city"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
               
                <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Google Map"}
                    name={"map_link"}
                    placeholder={"Enter google map link"}
                    // required
                    disabled={mode == "Approval"}
                  />
                </Col>

                 <Col xs="12" sm="6" md="4" lg="3" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={" Full Address"}
                    name={"address"}
                    placeholder={"Enter full address"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>

                <Col md="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Latitude"}
                    name={"latitude"}
                    placeholder={"Latitude"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Longitude"}
                    name={"longitude"}
                    placeholder={"Longitude"}
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
              </Row>
              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default StepTwoPharmacy;
